/* global Localize */
import React, { useEffect, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import { logout, setLanguage, updateAppUser as updateAppUserAction } from 'store/actions/app'
import queryString from 'query-string'
import moment from 'moment'

import { callApi } from 'utils/api'
import { getStateValue } from 'store/selectors'
import documentItemActions from 'store/actions/documents_items'
import serviceOrderActions from '../../store/actions/service_orders'
import './Header.scss'
import sysModuleRelActions from '../../store/actions/sys_module_rel'
import internalOrderActions from 'store/actions/internal_order'
import storageActions from 'store/actions/storages'
import chat_passengerActions from 'store/actions/chat_passenger'
import ReactTooltip from 'react-tooltip'
import ModalMenu from 'components/ModalMenu/ModalMenu';
import programingServicesActions from 'store/actions/programing_services'
import { useUniversalLateralMenuHook } from 'hooks/useUniversalLateralMenuHook'
import icons from 'components/Icons.js'
import {
  Button,
  Dropdown,
  Grid,
  Header,
  Icon,
  Image,
  Label,
  List,
  Menu,
  Message,
  Popup,
  Segment,
  ButtonContent,
  Divider,
  Dimmer
} from 'semantic-ui-react'
import { FaChartBar, FaMapLocationDot } from 'react-icons/fa6'
import { Link } from 'react-router-dom'
import styles from './../../styles/global.module.scss'
import { compose } from 'redux'
import Search from 'components/CustomSearch/CustomSearch'
import NotificationSettingsIcon from 'components/custom-icons/NotificationSettingsIcon'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ACTIVE_LANGS } from 'translation/langs'
import { filterModulesForSearch } from 'utils/moduleFilters'
import HeaderSeparator from './HeaderSeparator'
import OnboardingProgressBar from 'components/OnboardingProgressBar'
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min'
import onboardingActions from 'store/actions/onboarding'
import userActions from 'store/actions/users'
import ContentOverlayLoader from 'components/ContentOverlayLoader'
import LanguageIcon from '../../images/language_icon.png'

const NOTIF_STORAGE_KEY = "notification_settings_v1"
const TOUR_CONTROL_EVENT = 'erp-tour-control'

const DEFAULT_NOTIFICATION_SETTINGS = {
  employee_license: true,
  documents_expiring: true,
  documents_expired: true,
  traffic_tickets: true,
  fast_cards: true,
  waiting_orders: true,
  pending_orders: true,
  delayed_orders: true,
  pending_articles: true,
  programmed_orders: true,
  expired_service_orders: true,
}

const getAvatar = (user, client, supplier, passenger) => {
  if (user?.image && user?.image.length > 0) {
    return user.image
  } else if (client?.image && client?.image.length > 0) {
    return client.image
  } else if (supplier?.image && supplier?.image.length > 0) {
    return supplier.image
  } else if (passenger?.image && passenger?.image.length > 0) {
    return passenger.image
  } else {
    let name = 'Guest'
    if (user) {
      name = user?.entity?.name ?? user?.username
    }
    if (client) {
      name = client?.code
    }
    return `https://ui-avatars.com/api/?name=${name}`
  }
}

const headerLinkDictionary = {
  'Tareas Internas': 'internal-orders',
  'Caseta': 'guard-booth',
  'Taller': 'service-orders',
  'Documentos': 'documents',
  'Suministro': 'fuel-supply',
}

const HeaderComponent = (props) => {
  const {
    user,
    client,
    passenger,
    supplier,
    rest,
    logout,
    history,
    expirations,
    employees,
    setExpand,
    openModal,
    setOpenModal,
    mobileOnly,
    previousExpand,
    setPreviousExpand,
    service_orders,
    expand,//expand del sidebar
    onboarding,
    communicationUsers,
    loadOnboardingProgress,
    updateTourSettings,
    updateAppUser,
    openCommunicationModal,
    lang,
  } = props

  const { t, i18n } = useTranslation();

  const isSidebarExpanded = mobileOnly ? expand === 1 : expand === null || expand === 1;

  const zeroIfMobile = (base = {}) =>
    mobileOnly
      ? {
        ...base,
        margin: 0,
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: 0,
        padding: 0,
        paddingLeft: 0,
        paddingRight: 0,
      }
      : base

  // lateralMenu ahora viene del hook con persistencia en backend
  const { lateralMenu, setLateralMenu, loading: sidebarLoading } = useUniversalLateralMenuHook('user');
  const [modalVisible, setModalVisible] = useState(false)
  const [employes, setEmployees] = useState([])
  const [hasEmployeeRights, setHasEmployeeRights] = useState(false)
  const [canCheckLicense, setCanCheckLicense] = useState(false)
  const [hasDocumentsRights, setHasDocumentsRights] = useState(false)
  const [notificationsCount, setNotificationsCount] = useState(10)
  const [listServiceOrders, setListServiceOrders] = useState([])
  const [pendingOrders, setPendingOrders] = useState([])
  const [delayedOrders, setDelayedOrders] = useState([])
  const [waitingOrders, setWaitingOrders] = useState([])
  const [sysModuleRels, setSysModuleRels] = useState([])
  const [reportMaxMin, setReportMaxMin] = useState([])
  const [pendingArticles, setPendingArticles] = useState([])

  // Modal Menu
  const [modalMenuVisible, setModalMenuVisible] = useState(false)
  const [notifPopupOpen, setNotifPopupOpen] = useState(false)
  const [tutorialPopupOpen, setTutorialPopupOpen] = useState(false)
  const [modalMenuTitle, setModalMenuTitle] = useState('')
  const [isOnboardingBarDismissed, setIsOnboardingBarDismissed] = useState(false)

  const handleModalMenuOpen = (title = '') => {
    setModalVisible(false);
    setNotifPopupOpen(false)
    setModalMenuTitle(title)
    setModalMenuVisible(true);
    // Esto cierra el Popup de usuario/avatar
  }
  const handleModalMenuClose = () => setModalMenuVisible(false)
  const [ordersCreateForProgramingServices, setOrdersCreateForProgramingServices] = useState(0)
  const [internalOrdersCount, setInternalOrdersCount] = useState(0)
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  // Service Orders
  const [expiredServiceOrdersCount, setExpiredServiceOrdersCount] = useState(0)

  const [notificationSettingsLocal, setNotificationSettingsLocal] = useState(() => {
    try {
      const s = localStorage.getItem(NOTIF_STORAGE_KEY)
      if (s) return JSON.parse(s)
    } catch (e) { }
    return DEFAULT_NOTIFICATION_SETTINGS
  })

  const location = useLocation();

  const navigateSearchParams = useMemo(() => {
    const queryParameters = new URLSearchParams();
    const url = location.pathname.slice(1);
    const module = props?.user?.modules.find((m) => m.url === url)
    if (module) {
      const group = module.module_group;
      const navigationLink = headerLinkDictionary[group];
      if (navigationLink) {
        queryParameters.set('process', navigationLink);
      }
    }
    if (!queryParameters.has('process')) {
      const firstHeaderLink = Object.values(headerLinkDictionary)[0];
      queryParameters.set('process', firstHeaderLink);
    }
    return queryParameters;
  }, [location.pathname, props.user]);

  const unreadMessagesCount = useMemo(() => {
    const total = props.unreadMessages?.reduce((acc, m) => acc + Number(m.unread_count || 0), 0)
    return Math.min(total ?? 0, 99)
  }, [props.unreadMessages])

  const unreadMessagesDigits = String(unreadMessagesCount || 0).length

  const messagesLabelStyle = useMemo(() => {
    if (unreadMessagesDigits <= 2) {
      // mantener círculo (ancho = alto) para 1-2 dígitos
      // const size = unreadMessagesDigits === 1 ? 16 : 18
      const size = 24
      return {
        fontFamily: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
        fontSize: '1em',
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: '50%',
        minWidth: `${size}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        top: '-8px',
        right: '-8px',
        // display: 'inline-block',
      }
    } else {
      // para 3 o más dígitos, usar forma "píldora" ajustable en ancho
      const height = 18
      const extra = (unreadMessagesDigits - 2) * 8 // ajustar espacio por dígito extra
      const minW = height + extra + 6
      return {
        fontFamily: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
        fontSize: '1.0em',
        height: `${height}px`,
        padding: '0 8px',
        borderRadius: '999px',
        minWidth: `${minW}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        top: '-8px',
        right: '-10px',
        display: 'inline-block',
      }
    }
  }, [unreadMessagesDigits])

  useEffect(() => {
    // cuando el modal de configuración se cierra recargar settings desde localStorage
    if (!modalMenuVisible) {
      try {
        const s = localStorage.getItem(NOTIF_STORAGE_KEY)
        if (s) setNotificationSettingsLocal(JSON.parse(s))
      } catch (e) { }
    }
  }, [modalMenuVisible])

  const isEnabledLocal = (key) => {
    return notificationSettingsLocal?.[key] !== false
  }

  useEffect(() => {
    let count = 0
    if (isEnabledLocal('employee_license')) count += employes?.length ?? 0
    if (isEnabledLocal('documents_expiring')) count += expirations?.DocumentsExpiring?.length ?? 0
    if (isEnabledLocal('documents_expired')) count += expirations?.Documents?.length ?? 0
    if (isEnabledLocal('traffic_tickets')) count += expirations?.TrafficTickets?.length ?? 0
    if (isEnabledLocal('fast_cards')) count += expirations?.FastCards?.length ?? 0
    if (isEnabledLocal('pending_orders')) count += pendingOrders?.length ?? 0
    if (isEnabledLocal('delayed_orders')) count += delayedOrders?.length ?? 0
    if (isEnabledLocal('waiting_orders')) count += waitingOrders?.length ?? 0
    if (isEnabledLocal('pending_articles')) count += pendingArticles?.length ?? 0
    if (isEnabledLocal('expired_service_orders')) count += expiredServiceOrdersCount ?? 0
    if (isEnabledLocal('programmed_orders')) count += ordersCreateForProgramingServices ?? 0
    count += internalOrdersCount ?? 0

    setNotificationsCount(count)
  }, [
    employes,
    expirations,
    pendingOrders,
    delayedOrders,
    waitingOrders,
    pendingArticles,
    expiredServiceOrdersCount,
    notificationSettingsLocal,
    ordersCreateForProgramingServices,
    internalOrdersCount
  ])

  useEffect(() => {
    const fetchExpiredServiceOrdersCount = async () => {
      const { expiredServiceOrdersCount } =
        await props.getExpiredServiceOrdersCount()
      setExpiredServiceOrdersCount(expiredServiceOrdersCount)
    }
    fetchExpiredServiceOrdersCount()
  }, [])

  useEffect(() => {
    const fetchGetUnreadInternalOrderNotificationsCount = async () => {
      const { unreadInternalOrderNotificationsCount } = await props.getUnreadInternalOrderNotificationsCount()
      setInternalOrdersCount(unreadInternalOrderNotificationsCount)
    }
    fetchGetUnreadInternalOrderNotificationsCount()
  }, [])

  useEffect(() => {
    let isMounted = true

    const module = props?.user?.modules?.find((m) => {
      if (m.url !== '') {
        const url = props?.history?.location?.pathname?.substr(1)
        return url === m.url || url.startsWith(`${m.url}/`)
      }
      return false
    })

    if (module?.id) {
      const func = async () => {
        const data = await props.getSysModulesRel(module?.id)

        if (isMounted) {
          setSysModuleRels(data)
        }
      }

      func()
    }

    return () => {
      isMounted = false
    }
  }, [props?.user?.modules, props?.history?.location?.pathname])

  const moduleRelsOpts = useMemo(() => { 
    return props?.user?.modules
      ?.filter((m) => {
        return !!sysModuleRels.find(({ id_acceso }) => id_acceso == m.id)
      })
      .map((m) => ({
        key: m.id ?? m.name,
        text: (
          <div
            onClick={() => {
              window.open(`/${m.url}`, '_blank')
            }}
          >
            <Menu.Item
              className={styles.growOnHover}
              style={zeroIfMobile({ margin: '0', color: 'black' })}
            >
              {t(m.name)}
            </Menu.Item>
          </div>
        ),
      }))
  }, [sysModuleRels])

  const processOpts = useMemo(() => {
    return props?.user?.last_visits?.map((m) => ({
      key: m.id ?? m.url ?? m.name,
      text: (
        <Link
          to={`/${m.url}`}
          className={styles.growOnHover}
          style={zeroIfMobile({ margin: '0', color: 'black' })}
        >
          <Menu.Item
            className={styles.growOnHover}
            style={zeroIfMobile({ margin: '0', color: 'black' })}
          >
            {t(m.name)}
          </Menu.Item>
        </Link>
      ),
    }))
  }, [props?.user])

  const processesOptionsSearchbar = useMemo(
    () => filterModulesForSearch(props?.user?.modules, props?.user, t),
    [props?.user?.modules, props?.user, t]
  )

  const componentDidMount = async () => {
    //const startOfMonth = moment().subtract(45, 'days').format('YYYY-MM-DD');
    const endOfMonth = moment().add(45, 'days').format('YYYY-MM-DD')
    let res = await callApi(
      `/employee?license_expiration_date.lte=${endOfMonth}&active.eq=1`,
      {
        method: 'GET',
        headers: {
          Authorization: user.token,
        },
      }
    )
    setEmployees(res.body)

    // let list = await props.loadAndUpdate()
    // setListServiceOrders(list)
  }

  useEffect(() => {
    setPendingOrders(listServiceOrders.filter((o) => o.status === 'PENDIENTE'))
    setDelayedOrders(
      listServiceOrders.filter((order) => order.status === 'ATRASADA')
    )
    setWaitingOrders(
      listServiceOrders.filter((order) => order.status === 'EN ESPERA')
    )
    // console.log("Filtered Service Orders:", listServiceOrders)
    // setOrdersCreateForProgramingServices(
    //   listServiceOrders.filter((o) => o.origin == "PROGRAMACION")
    // )
  }, [listServiceOrders])

  // useEffect(async () => {
  //   let count = await props.loadCountOrderServices()
  //   setOrdersCreateForProgramingServices(parseInt(count?.count))
  //   hasDocumentsRights && props.loadExpirationReport()
  // }, [hasDocumentsRights])
  useEffect(() => {
    const loadData = async () => {
      if (!user?.token) return

      const promises = [props.loadCountOrderServices()]

      if (hasDocumentsRights) {
        promises.push(props.loadExpirationReport())
      }

      try {
        const [count] = await Promise.all(promises)
        setOrdersCreateForProgramingServices(parseInt(count?.count))
      } catch (e) {
        // Evita romper el render durante transiciones de sesión (logout/login)
      }
    }

    loadData()
  }, [hasDocumentsRights, user?.token])

  useEffect(() => {
    setHasDocumentsRights(user?.modules?.findIndex((m) => m.id === 102) > -1)
  }, [props.user])

  useEffect(async () => {
    let options = {}
    options.groupBy = 'article'
    let response = await props.getReportMaxMin(options)
    setReportMaxMin(response)
  }, [])

  useEffect(() => {
    if (!reportMaxMin || reportMaxMin.length === 0) return

    const articles = reportMaxMin
      .map((row) => {
        const max_quantity = row?.Article?.maximum_quantity ?? 0

        return {
          ...row,
          pending_quantity:
            max_quantity > row.quantity ? max_quantity - row.quantity : 0,
        }
      })
      .filter((row) => row.pending_quantity > 0)

    setPendingArticles(articles)
  }, [reportMaxMin])

  // useEffect(() => {
  //   let count = employes?.length ?? 0
  //   count += expirations?.Documents?.length ?? 0
  //   count += expirations?.TrafficTickets?.length ?? 0
  //   count += expirations?.FastCards?.length ?? 0
  //   count += pendingOrders?.length ?? 0
  //   count += delayedOrders?.length ?? 0
  //   count += waitingOrders?.length ?? 0
  //   count += pendingArticles?.length ?? 0
  //   count += expiredServiceOrdersCount ?? 0
  //   setNotificationsCount(count)
  // }, [
  //   employes,
  //   expirations,
  //   pendingOrders,
  //   delayedOrders,
  //   waitingOrders,
  //   pendingArticles,
  //   expiredServiceOrdersCount,
  // ])

  useEffect(() => {
    let employeePermissions = user?.modules?.find(
      (m) => m.url === 'employees'
    )?.permisitions

    if (employeePermissions?.ACCESS) {
      componentDidMount()
    }

    setCanCheckLicense(employeePermissions)
  }, [employees])

  //const [language, setLanguage] = useState(Localize.getLanguage())
  const [language, setLanguage] = useState(() => {
    const storedLang = localStorage.getItem('@language');
    return storedLang || Localize.getLanguage() || 'es';
  })

  useEffect(() => {
    // Sincronizar con localStorage si cambia externamente (opcional, pero útil)
    const storedLang = localStorage.getItem('@language');
    if (storedLang && storedLang !== language) {
      setLanguage(storedLang);
    }
  }, [language]);

  const logoutModal = () => {
    localStorage.setItem('showModal', 'true')
  }

  let userName = user?.username || rest?.user?.username

  // tamaño adaptativo del label de notificaciones según cantidad de dígitos
  const notifDigits = String(notificationsCount || 0).length
  const notifLabelStyle = (() => {
    if (notifDigits <= 2) {
      // mantener círculo (ancho = alto) para 1-2 dígitos
      const size = notifDigits === 1 ? 16 : 18
      return {
        fontFamily: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
        fontSize: '.75em',
        width: `${size}px`,
        height: `${size}px`,
        padding: 0,
        borderRadius: '50%',
        minWidth: `${size}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        top: '-8px',
        right: '-8px',
        display: 'inline-block',
      }
    } else {
      // para 3 o más dígitos, usar forma "píldora" ajustable en ancho
      const height = 18
      const extra = (notifDigits - 2) * 8 // ajustar espacio por dígito extra
      const minW = height + extra + 6
      return {
        fontFamily: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
        fontSize: '1.0em',
        height: `${height}px`,
        padding: '0 8px',
        borderRadius: '999px',
        minWidth: `${minW}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        top: '-8px',
        right: '-10px',
        display: 'inline-block',
      }
    }
  })()

  const isNotificationsAccessGranted = useMemo(() =>
    props?.user?.modules.find(module => module.url === 'settings/notifications')?.permisitions?.ACCESS ?? false
    , [props.user]);
  const canAccessTutorial = !!user?.can_access_tutorial
  const isTutorialOmitted = canAccessTutorial && (user?.tour_enabled === false)

  useEffect(() => {
    if (isTutorialOmitted || onboarding?.isComplete) {
      setIsOnboardingBarDismissed(true)
      return
    }

    if (!onboarding?.isComplete) {
      setIsOnboardingBarDismissed(false)
    }
  }, [onboarding?.isComplete, isTutorialOmitted])

  const persistTourEnabled = async (enabled) => {
    if (!user?.id || !user?.sys_company_id) return false

    const payload = {
      userId: user.id,
      id: user.id,
      sys_company_id: user.sys_company_id,
      tour_enabled: enabled,
    }

    try {
      await updateTourSettings(payload)
      updateAppUser({ tour_enabled: enabled })
      return true
    } catch (error) {
      console.error('Error actualizando preferencia de tutorial:', error)
      return false
    }
  }

  const handleViewTutorial = async () => {
    if (!canAccessTutorial || !user?.id) return

    if (user?.tour_enabled === false) {
      const wasUpdated = await persistTourEnabled(true)
      if (!wasUpdated) return
      window.dispatchEvent(new CustomEvent(TOUR_CONTROL_EVENT, { detail: { action: 'enable-all' } }))
    }

    if (!onboarding?.isComplete) {
      setIsOnboardingBarDismissed(false)
    }
    setTutorialPopupOpen(false)
    window.dispatchEvent(new CustomEvent(TOUR_CONTROL_EVENT, { detail: { action: 'start-current' } }))
  }

  const handleSkipTutorial = async () => {
    if (!canAccessTutorial || !user?.id) return

    const wasUpdated = await persistTourEnabled(false)
    if (!wasUpdated) return

    setIsOnboardingBarDismissed(true)
    setTutorialPopupOpen(false)
    window.dispatchEvent(new CustomEvent(TOUR_CONTROL_EVENT, { detail: { action: 'disable-all' } }))
  }

  return (

    <>
      <Menu
        className='NavBar__Header'
        inverted
        borderless
        size='tiny'
        attached='top'
        fixed='top'
        style={zeroIfMobile({
          // desplazar solo en desktop cuando el lateral está expandido (null o 1)
          left: !mobileOnly && (expand == null || expand == 1) ? 225 : 0,
          width: !mobileOnly && (expand == null || expand == 1) ? 'calc(100% - 225px)' : '100%',
          transition: 'left 0.5s ease, width 0.5s ease',
          boxShadow: '10px 1px 12px 0px rgba(0,0,0,0.10)',
        })}
      >

        {/* Menu icon moved into the SubMenu below so it shifts together with other buttons */}

        {isSidebarExpanded && (
          <div
            className='HeaderSeparator HeaderSeparator--vertical'
            style={zeroIfMobile({
              width: '.1px',
              height: '50px', // ajustar alto según necesidad
              background: 'hsla(0, 0%, 90%, 0.00)',
              margin: '0 6px',
              marginLeft: '-3px',
              //marginRight: '-1px',
              alignSelf: 'center',
              display: 'inline-block',
              marginRight: '21px',
            })}
          />

        )}
        <Menu className='SubMenu__Header' size='mini' secondary style={zeroIfMobile({
          // move the whole group (menu/dashboard/help/gps and separators) when sidebar opens
          marginLeft: (!mobileOnly && isSidebarExpanded) ? 8 : 0,
          transition: 'margin-left 0.24s ease',
          display: 'inline-flex',
          alignItems: 'center'
        })}>

          {/* Menu icon: moved inside the SubMenu so it shifts together with other buttons */}
          <Menu.Item fitted className='NavBar__Item NavBar__SidebarToggle' style={zeroIfMobile({ padding: 0, marginRight: 6 })}>
            {(!isSidebarExpanded || mobileOnly) && (
              <img
                src='https://img.icons8.com/?size=100&id=g5dx3VExcn2X&format=png&color=000000'
                alt={t('Menu')}
                className='NavBar__Item NavBar__SidebarToggle'
                style={{
                  width: 30,
                  height: 30,
                  cursor: 'pointer',
                  display: 'inline-block',
                  verticalAlign: 'middle',
                  pointerEvents: 'auto'
                }}
                onClick={() => {
                  setExpand((previousExpandedState) => {
                    setPreviousExpand(previousExpandedState)

                    if (!mobileOnly)
                      return previousExpandedState == 1
                        ? previousExpand == null || previousExpand == 2
                          ? 0
                          : 2
                        : 1

                    return !previousExpandedState ? 1 : 0
                  })
                }}
              />
            )}
          </Menu.Item>

          {/* Solo mostrar searchbar cuando el sidebar está cerrado */}
          {(!isSidebarExpanded && !mobileOnly) && (
            <Menu.Item fitted position='right'>
              <div
                style={zeroIfMobile({
                  marginLeft: '25px',
                })}
              >
                <Search
                  fluid
                  className='SearchInput'
                  resultsClassName='erp-header-search-results'
                  onSelectOption={(data) => {
                    props.history.push(`/${data.value}`)
                  }}
                  options={processesOptionsSearchbar}
                />
              </div>
            </Menu.Item>
          )}

          <Menu.Item fitted position='right' data-tip data-for='dashboard-tooltip' style={mobileOnly ? { padding: 0, margin: -2 } : undefined}>
            {/* <FaChartBar style={{ transform: "rotate(90deg) scaleX(-1) translateX(-2px)" }} /> */}
            <a
              href={process.env.REACT_APP_DASHBOARD_URL}
              style={{ display: 'inline-flex', alignItems: 'center' }}
            >
              <img
                data-tip
                data-for='dashboard-tooltip'
                src='https://img.icons8.com/?size=100&id=DAoPjn2XoTUN&format=png&color=000000' // <-- reemplaza por la URL/prop de Icons.js
                alt={t('Dashboard')}
                className='NavBar__Item'
                style={{ width: 30, height: 30, display: 'inline-block', verticalAlign: 'middle' }}
              />
            </a>
          </Menu.Item>
          <ReactTooltip id='dashboard-tooltip' place='top' effect='solid' className='tooltip-mini' offset={{ right: 2 }}>
            {t('Dashboard')}
          </ReactTooltip>

          <Menu.Item fitted position='right' style={mobileOnly ? { padding: 0, margin: -2 } : undefined}>
            <div
              style={zeroIfMobile({
                marginLeft: 4,
                //backgroundColor: "#F8F9FF", // 👈 try this instead of pure white
                borderRadius: "50%",
                width: 30,
                height: 30,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "none",                // removes Semantic's shadow border
                outline: "none",                  // extra safety
              })}
            >
              {/* <Icon
              className='Circle_Icon NavBar__Item'
              name='question'
              circular
              style={{
                margin: 0,
                boxShadow: "none",              // prevent inner border shadow
                background: "transparent",      // clean background
              }}
              onClick={() => {
                setOpenModal(!openModal)
              }}
            /> */}
              <img
                data-tip
                data-for='help-tooltip'
                src='https://img.icons8.com/?size=100&id=p4rXi9HURgXT&format=png&color=000000' // <-- reemplaza por la URL/prop de Icons.js
                alt={t('Ayuda')}
                className='NavBar__Item'
                style={{ width: 30, height: 30, cursor: 'pointer' }}
                onClick={() => { setOpenModal(!openModal) }}
              />
            </div>
          </Menu.Item>
          <ReactTooltip id='help-tooltip' place='top' effect='solid' className='tooltip-mini' offset={{ right: 2 }}>
            {t('Ayuda')}
          </ReactTooltip> 

          <Menu.Item fitted position='right' >
            <a
              target='blank'
              href={'https://www.geologisticgurtam.com/'}
              style={{ display: 'inline-flex', alignItems: 'center' }}
            >
              {/* <FaMapLocationDot /> */}
              <img
                data-tip data-for='gps-tooltip'
                src='https://img.icons8.com/?size=100&id=ZPLpfsKE1OLu&format=png&color=000000' // <-- reemplaza por la URL/prop de Icons.js
                alt={t('GPS')}
                className='NavBar__Item'
                style={{ width: 30, height: 30, display: 'inline-block', verticalAlign: 'middle' }}
              />
            </a>
          </Menu.Item>
          <ReactTooltip id='gps-tooltip' place='top' effect='solid' className='tooltip-mini'>
            {t('Plataforma GPS')}
          </ReactTooltip>

          {/* <Menu.Item fitted position='right'>
          <div
            style={{
              marginLeft: '25px',
            }}
          >
            <Search
              fluid
              className='SearchInput'
              onSelectOption={(data) => {
                props.history.push(`/${data.value}`)
              }}
              options={processesOptionsSearchbar}
            />
          </div>
        </Menu.Item> */}
        </Menu>

        {/* OnboardingProgressBar - centrado, oculto en móvil */}
        {!mobileOnly && !isOnboardingBarDismissed && !isTutorialOmitted && (
          <div style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            <div className='HeaderTutorialContainer' style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              {canAccessTutorial && (
                <OnboardingProgressBar
                  onboarding={onboarding}
                  loadOnboardingProgress={loadOnboardingProgress}
                  history={history}
                  onDismiss={() => setIsOnboardingBarDismissed(true)}
                />
              )}
              {canAccessTutorial && (
                <>
                  <Popup
                    open={tutorialPopupOpen}
                    onOpen={() => setTutorialPopupOpen(true)}
                    onClose={() => setTutorialPopupOpen(false)}
                    on='click'
                    position='bottom center'
                    trigger={(
                      <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <span
                          className='NavBar__TutorialTrigger'
                        >
                          {t('Tutorial')}
                        </span>
                      </span>
                    )}
                    content={(
                      <div className='HeaderTutorialMenu'>
                        <Button size='mini' fluid primary onClick={handleViewTutorial}>
                          {t('Ver tutorial')}
                        </Button>
                        <Button size='mini' fluid basic color='grey' onClick={handleSkipTutorial}>
                          {t('Omitir tutorial')}
                        </Button>
                      </div>
                    )}
                  />
                </>
              )}
            </div>
          </div>
        )}

        <Menu.Menu position={mobileOnly ? null : 'right'} size='tiny'>
          {/* Icono de Tutorial cuando la barra está oculta/completada */}
          {!mobileOnly && canAccessTutorial && isOnboardingBarDismissed && (
            <Menu.Item fitted position='right' style={{ padding: 0, marginRight: 0 }}>
              <Popup
                open={tutorialPopupOpen}
                onOpen={() => setTutorialPopupOpen(true)}
                onClose={() => setTutorialPopupOpen(false)}
                on='click'
                position='bottom center'
                trigger={(
                  <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    <span
                      className='NavBar__TutorialTrigger NavBar__TutorialTrigger--moved'
                    >
                      {t('Tutorial')}
                    </span>
                  </span>
                )}
                content={(
                  <div className='HeaderTutorialMenu'>
                    <Button size='mini' fluid primary onClick={handleViewTutorial}>
                      {t('Ver tutorial')}
                    </Button>
                    <Button size='mini' fluid basic color='grey' onClick={handleSkipTutorial}>
                      {t('Omitir tutorial')}
                    </Button>
                  </div>
                )}
              />
            </Menu.Item>
          )}
          {/* 
        <Menu.Item fitted position='right' style={mobileOnly ? { padding: 0, marginRight: -15 } : undefined}>
          <Dropdown trigger={

            <img
              data-tip data-for='accesos-tooltip'
              src='https://img.icons8.com/?size=100&id=SvkXyXOmymmb&format=png&color=000000'
              alt={t('Catálogos')}
              className='NavBar__Item'
              style={{ width: 30, height: 30, cursor: 'pointer' }}
            />
          } options={processOpts} />
        </Menu.Item>
        <ReactTooltip id='accesos-tooltip' place='top' effect='solid' className='tooltip-mini' offset={{ right: 2 }}>
          {t('Accesos Directos')}
        </ReactTooltip> */}
          <Menu.Item fitted position='right' style={mobileOnly ? { padding: 0 } : undefined}>
            <a
              target='blank'
              onClick={() => {
                window.open('/procedures', '_blank')
              }}
              style={zeroIfMobile({ display: 'inline-flex', alignItems: 'center', cursor: 'pointer', ...(!mobileOnly ? { padding: '0 10px', marginRight: 10 } : {}) })}
            >
              <img
                data-tip
                data-for='procedimientos-tooltip'
                src='https://img.icons8.com/?size=100&id=bwUgs69v7bOd&format=png&color=000000'
                alt={t('Procedimientos')}
                className='NavBar__Item'
                style={{ width: 28, height: 28, display: 'inline-block', verticalAlign: 'middle' }}
              />
            </a>
            {/* <Button
            primary
            style={{ backgroundColor: '#003366', color: '#fff' }}
            onClick={() => {
              window.open('/procedures', '_blank')
            }}
          >
            Procedimientos
          </Button> */}
          </Menu.Item>
          <ReactTooltip id='procedimientos-tooltip' place='top' effect='solid' className='tooltip-mini' offset={{ right: 2 }}>
            {t('Procedimientos')}
          </ReactTooltip>
          {/* <Menu.Item fitted position='right' style={mobileOnly ? { padding: 0 } : undefined}>
          <Dropdown style={{ margin: 0, padding: 0 }} trigger={
            <img
              data-tip
              data-for='catalog-tooltip'
              src='https://img.icons8.com/?size=100&id=2s0NBaucNEOt&format=png&color=000000'
              alt={t('Catálogos')}
              className='NavBar__Item'
              style={mobileOnly ? { width: 30, height: 30, cursor: 'pointer', marginRight: -30 } : { width: 30, height: 30, cursor: 'pointer' }}
            />
          } options={moduleRelsOpts} />
        </Menu.Item>
        <ReactTooltip id='catalog-tooltip' place='top' effect='solid' className='tooltip-mini' offset={{ right: 2 }}>
          {t('Catálogos')}
        </ReactTooltip> */}

          {/* <Menu.Item position='right' >
          <a
            href='https://www.jotform.com/build/241557916166060'
            target='_blank'
            rel='noopener noreferrer'
            style={zeroIfMobile({ color: 'white', borderLeft: '1px solid rgba(0,0,0,0.1)', ...(!mobileOnly ? { marginRight: 2, paddingLeft: 10 } : {}) })}
          >
            <img
              data-tip
              data-for='bug-tooltip'
              src='https://img.icons8.com/?size=100&id=oR0Jee7LrnqA&format=png&color=000000' // <-- reemplaza por la URL/prop de Icons.js
              alt={t('Reportar problema')}
              className='NavBar__Item'
              style={{ width: 30, height: 30, display: 'inline-block', verticalAlign: 'middle' }}
            />
          </a>
        </Menu.Item>
        <ReactTooltip id='bug-tooltip' place='top' effect='solid' className='tooltip-mini' offset={{ right: 2 }}>
          {t('Reportar un problema')}
        </ReactTooltip> */}

          {/* Notificaciones */}
          <Menu.Item position='right' fitted className='NavBar__Item' >
            {(canCheckLicense || hasDocumentsRights || communicationUsers?.length >= 1) && (
              <Popup
                className='Header__NotificationsPopup'
                pinned
                open={notifPopupOpen && !modalMenuVisible}
                onOpen={() => setNotifPopupOpen(true)}
                onClose={() => setNotifPopupOpen(false)}
                trigger={
                  <Menu.Item
                    className='NavBar__Item'
                  >
                    {/* <Icon
                    className='NavBar__Outline'
                    size='big'
                    name='bell'
                    fitted
                  >
                    {notificationsCount > 0 && (
                      <Label
                        color='red'
                        floating
                        circular
                        style={{
                          fontFamily:
                            "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
                          fontSize: '0.45em',
                        }}
                      >
                        {notificationsCount}
                      </Label>
                    )}
                  </Icon> */}
                    <div style={zeroIfMobile({ borderRight: '1px solid rgba(0,0,0,0.1)', paddingRight: 12 })}>

                      <div style={{ position: 'relative', display: 'inline-block', }}>
                        <img
                          src='https://img.icons8.com/?size=100&id=6oSO0y87LIU5&format=png&color=000000' // <-- reemplaza por la URL/prop de Icons.js
                          alt={t('Notificaciones')}
                          className='NavBar__Item'
                          style={{ width: 30, height: 30, display: 'inline-block', verticalAlign: 'middle' }}
                        />

                        {notificationsCount > 0 && (
                          <Label
                            color='red'
                            floating
                            circular
                            // style={{
                            //   fontFamily:
                            //     "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
                            //   fontSize: '0.75em',
                            //   position: 'absolute',
                            //   top: '-8px',
                            //   right: '-8px',
                            // }}
                            style={notifLabelStyle}

                          >
                            {notificationsCount}
                          </Label>
                        )}
                      </div>
                    </div>

                  </Menu.Item>
                }
                content={!modalMenuVisible && (
                  <div>
                    {notificationsCount == 0 && (
                      <Message
                        size='tiny'
                        warning
                        icon='info'
                        header={t('No hay notificaciones')}
                      />
                    )}
                    {isEnabledLocal('employee_license') && employes.length > 0 && (
                      <Message
                        size='tiny'
                        onClick={() => {
                          history.replace({
                            pathname: '/employees',
                            search: queryString.stringify({
                              filter: employes.map((e) => e.id).join(','),
                            }),
                          })
                        }}
                        warning
                        icon='warning'
                        header={employes.length + ' ' + (employes.length > 1 ? t('licencias vencen en menos de 45 días') : t('licencia vence en menos de 45 días'))}
                        content={t('Click aquí para ver detalles')}
                      />
                    )}

                    {isEnabledLocal('documents_expiring') && expirations.Documents?.filter(
                      (it) => it.actual_status == 'POR VENCER'
                    ).length > 0 && (
                        <Message
                          size='tiny'
                          onClick={() => {
                            history.replace({
                              pathname: '/document_items',
                              search: queryString.stringify({
                                por_vencer: true,
                              }),
                            })
                            window.location.reload() // Recargar la página
                          }}
                          warning
                          icon='warning'
                          header={expirations.Documents?.filter((it) => it.actual_status == 'POR VENCER').length + ' ' + (expirations.Documents?.filter((it) => it.actual_status == 'POR VENCER').length > 1 ? t('documentos por vencer') : t('documento por vencer'))}
                          content={t('Click aquí para ver detalles')}
                        />
                      )}

                    {isEnabledLocal('documents_expired') && expirations.Documents?.filter(
                      (it) => it.actual_status == 'VENCIDO'
                    ).length > 0 && (
                        <Message
                          size='tiny'
                          onClick={() => {
                            history.replace({
                              pathname: '/document_items',
                              search: queryString.stringify({
                                vencidos: true,
                              }),
                            })
                            window.location.reload() // Recargar la página
                          }}
                          warning
                          color='red'
                          icon='warning'
                          header={expirations.Documents?.filter((it) => it.actual_status == 'VENCIDO').length + ' ' + (expirations.Documents?.filter((it) => it.actual_status == 'VENCIDO').length > 1 ? t('documentos expirados') : t('documento expirado'))}
                          content={t('Click aquí para ver detalles')}
                        />
                      )}

                    {isEnabledLocal('traffic_tickets') && expirations.TrafficTickets?.length > 0 && (
                      <Message
                        size='tiny'
                        onClick={() => {
                          history.replace({
                            pathname: '/documents_expirations',
                            search: queryString.stringify({
                              tabId: 1,
                            }),
                          })
                        }}
                        warning
                        icon='warning'
                        header={expirations.TrafficTickets?.length + ' ' + (expirations.TrafficTickets?.length > 1 ? t('multas por vencer') : t('multa por vencer'))}
                        content={t('Click aquí para ver detalles')}
                      />
                    )}

                    {isEnabledLocal('fast_cards') && expirations.FastCards?.length > 0 && (
                      <Message
                        size='tiny'
                        onClick={() => {
                          history.replace({
                            pathname: '/documents_expirations',
                            search: queryString.stringify({
                              tabId: 2,
                            }),
                          })
                        }}
                        warning
                        icon='warning'
                        header={expirations.FastCards?.length + ' ' + (expirations.FastCards?.length > 1 ? t('Tarjetas Fast por vencer') : t('Tarjeta Fast por vencer'))}
                        content={t('Click aquí para ver detalles')}
                      />
                    )}
                    {isEnabledLocal('waiting_orders') && waitingOrders?.length > 0 && (
                      <Message
                        size='tiny'
                        onClick={() => {
                          history.replace({
                            pathname: '/workshop/service_order',
                            search: queryString.stringify({
                              filter: waitingOrders.map((e) => e.id).join(','),
                            }),
                          })
                        }}
                        warning
                        icon='warning'
                        header={waitingOrders?.length + ' ' + (waitingOrders?.length > 1 ? t('Ordenes en estatus EN ESPERA') : t('Orden en estatus EN ESPERA'))}
                        content={t('Click aquí para ver detalles')}
                      />
                    )}
                    {isEnabledLocal('pending_orders') && pendingOrders?.length > 0 && (
                      <Message
                        size='tiny'
                        onClick={() => {
                          history.replace({
                            pathname: '/workshop/service_order',
                            search: queryString.stringify({
                              filter: pendingOrders.map((e) => e.id).join(','),
                            }),
                          })
                        }}
                        color='orange'
                        icon='warning'
                        header={pendingOrders?.length + ' ' + (pendingOrders?.length > 1 ? t('Ordenes en estatus PENDIENTES') : t('Orden en estatus PENDIENTE'))}
                        content={t('Click aquí para ver detalles')}
                      />
                    )}
                    {isEnabledLocal('delayed_orders') && delayedOrders?.length > 0 && (
                      <Message
                        size='tiny'
                        onClick={() => {
                          history.replace({
                            pathname: '/workshop/service_order',
                            search: queryString.stringify({
                              filter: delayedOrders.map((e) => e.id).join(','),
                            }),
                          })
                        }}
                        color='red'
                        icon='warning'
                        header={delayedOrders?.length + ' ' + (delayedOrders?.length > 1 ? t('Ordenes en estatus ATRASADAS') : t('Orden en estatus ATRASADA'))}
                        content={t('Click aquí para ver detalles')}
                      />
                    )}
                    {isEnabledLocal('pending_articles') && pendingArticles?.length > 0 && (
                      <Message
                        size='tiny'
                        onClick={() => {
                          history.replace({
                            pathname: '/maxmin',
                            // search: queryString.stringify({
                            // 	filter: pendingArticles.map((e) => e.id).join(','),
                            // }),
                          })
                        }}
                        color='orange'
                        icon='warning'
                        header={pendingArticles?.length + ' ' + (pendingArticles?.length > 1 ? t('Artículos con inventario faltante') : t('Artículo con inventario faltante'))}
                        content={t('Click aquí para ver detalles')}
                      />
                    )}
                    {isEnabledLocal('programmed_orders') && ordersCreateForProgramingServices > 0 && (
                      <Message
                        size='tiny'
                        onClick={() => {
                          history.replace({
                            pathname: '/notifications',
                            search: '?type=serviceOrder',
                          })
                        }}
                        color='blue'
                        icon='warning'
                        header={ordersCreateForProgramingServices + ' ' + (ordersCreateForProgramingServices > 1 ? t('Ordenes programadas') : t('Orden programada'))}
                        content={t('Click aquí para ver detalles')}
                      />
                    )}
                    {isEnabledLocal('expired_service_orders') && expiredServiceOrdersCount > 0 && (
                      <Message
                        size='tiny'
                        onClick={() => {
                          history.replace({
                            pathname: '/workshop/service_order',
                          })
                        }}
                        color='purple'
                        icon='warning'
                        header={expiredServiceOrdersCount + ' ' + (expiredServiceOrdersCount > 1 ? t('Ordenes de servicio expiradas') : t('Orden de servicio expirada'))}
                        content={t('Click aquí para ver detalles')}
                      />
                    )}

                    {internalOrdersCount > 0 && (
                      <Message
                        size='tiny'
                        onClick={() => {
                          const searchParams = new URLSearchParams();
                          searchParams.set('type', 'internalOrder');
                          history.push({
                            pathname: '/notifications',
                            search: searchParams.toString(),
                          })
                        }}
                        color='teal'
                        icon='warning'
                        header={internalOrdersCount + ' ' + (internalOrdersCount > 1 ? t('Ordenes internas por completar') : t('Orden interna por completar'))}
                        content={t('Click aquí para ver detalles')}
                      />
                    )}

                    {/* Communications/announcements */}
                    {communicationUsers?.length >= 1 && (
                      <Message
                        size='tiny'
                        onClick={() => {
                          openCommunicationModal()
                          setNotifPopupOpen(false)
                        }}
                        color='purple'
                        icon='warning'
                        header={communicationUsers.length + ' ' +  t('Comunicados')}
                        content={t('Click aquí para ver detalles')}
                      />
                    )}

                    <div style={{ display: 'flex' }}>

                      {isNotificationsAccessGranted &&
                        // <Button
                        //   size='mini'
                        //   fluid
                        //   primary
                        //   style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        // >
                        //   <Icon name='eye' size='large' />
                        // </Button>
                        <Button primary icon fluid
                          onClick={() => handleModalMenuOpen(t('Configuración de Notificaciones'), { source: 'notifications' })}
                          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <ButtonContent visible style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            {/* <Icon name='eye' color='black' /> */}
                            {/* <img src='https://img.icons8.com/?size=100&id=38869&format=png&color=000000' style={{ width: '24px', height: '24px' }}></img> */}
                            <img src='https://img.icons8.com/?size=100&id=38869&format=png&color=000000' style={{ width: '25px', height: '25px' }}></img>
                          </ButtonContent>
                        </Button>
                      }

                      {isNotificationsAccessGranted && <Button
                        size='mini'
                        fluid
                        primary
                        onClick={() => {
                          window.open(`/settings/notifications?${navigateSearchParams.toString()}`, '_blank')
                        }}
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}
                      >
                        <NotificationSettingsIcon />
                        {t('Configurar')}
                      </Button>}

                      <Button
                        size='mini'
                        fluid
                        primary
                        onClick={() => {
                          history.push({
                            pathname: '/notifications',
                          })
                        }}
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}
                      >
                        {/* <Icon name='bell' color='yellow' size='large' /> */}
                        <img
                          src='https://img.icons8.com/?size=100&id=6oSO0y87LIU5&format=png&color=000000' // <-- reemplaza por la URL/prop de Icons.js
                          alt={t('Notificaciones')}
                          style={{ width: 25, height: 25, display: 'inline-block', verticalAlign: 'middle' }}
                        />
                        {t('Centro de Notificaciones')}
                      </Button>
                    </div>
                  </div>
                )
                }
                position='bottom right'
                on='click'
              />
            )}
          </Menu.Item>

          <ModalMenu open={modalMenuVisible} onClose={handleModalMenuClose} title={modalMenuTitle} profile={user ? "user" : null} />

          <Popup
            pinned
            disabled={!props.unreadMessages || props.unreadMessages.length === 0}
            trigger={(
              <Menu.Item
                fitted
                position='right'
                className='NavBar__Item'
                style={{ padding: '0 0.8em' }}
                onClick={() => {
                  if (!props.unreadMessages || props.unreadMessages.length === 0) {
                    history.push('/passengers?tab=3')
                  }
                }}
              >
                <div style={{ position: 'relative', display: 'inline-block' }}>
                  <img
                    src='https://img.icons8.com/?size=100&id=hCvhdugyicF1&format=png&color=000000'
                    alt={t('Chat')}
                    className='NavBar__Item'
                    style={{ width: 30, height: 30, cursor: 'pointer' }}
                  />
                  {unreadMessagesCount > 0 && (
                    <Label
                      color='red'
                      floating
                      circular
                      style={messagesLabelStyle}
                    >
                      {unreadMessagesCount}{unreadMessagesDigits > 2 ? <span style={{ fontSize: '0.9em' }}>+</span> : null}
                    </Label>
                  )}
                </div>
              </Menu.Item>
            )}
            content={
              <div>
                <div style={{ maxHeight: 200, overflowY: 'auto' }}>
                  <List selection divided verticalAlign='middle' style={{ marginTop: 0, marginBottom: 8 }}>
                    {(props.unreadMessages || []).map((m) => (
                      <List.Item
                        key={m.id}
                        onClick={() => {
                          props.setActiveChatId(m.chat_id)
                          history.push('/passengers?tab=3', {
                            header: {
                              chatId: m.chat_id,
                              clientId: m.ChatPassenger?.GroupPassenger?.client_id,
                            }
                          })
                        }}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          padding: '0.5em 0.75em',
                        }}
                      >
                        <List.Content
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            flex: 1,
                          }}
                        >
                          <List.Header
                            style={{
                              fontWeight: 500,
                              margin: 0,
                            }}
                          >
                            {m.ChatPassenger?.GroupPassenger?.name}
                          </List.Header>
                        </List.Content>

                        <Label circular>
                          {m.unread_count}
                        </Label>
                      </List.Item>
                    ))}
                  </List>
                </div>

                <div style={{ display: 'flex' }}>
                  <Button
                    size='mini'
                    fluid
                    primary
                    onClick={() => {
                      history.push('/passengers?tab=3')
                    }}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}
                  >
                    <Icon name='bell outline' />
                    {t('Todos los mensajes')}
                  </Button>
                </div>
              </div>
            }
            position='bottom right'
            on='click'
          />
          {!mobileOnly ? <HeaderSeparator /> : undefined}

          <Menu.Item fitted position='right' className='NavBar__Item' style={zeroIfMobile({ marginRight: 30 })}>
            <Popup
              open={modalVisible}
              onOpen={() => setModalVisible(true)}
              onClose={() => setModalVisible(false)}
              pinned
              on='click'
              trigger={
                <Menu.Item className='NavBar__Outline NavBar__Item' >
                  <Image
                    src={getAvatar(user, client, supplier, passenger)}
                    avatar
                  />
                  {!mobileOnly && <span className='NavBar__UserName'>
                    {(user?.email || user?.username || '').slice(0, 10)}
                  </span>}
                </Menu.Item>
              }
              content={
                <Segment className="Header_PopUp NavBar__Outline">
                  <div className="Header_PopUp_List">

                    {/* Logo */}
                    <div className="Header_PopUp_Button logo">
                      <Image
                        className="Header_PopUp_Image"
                        src={props.user?.sysCompanyImage?.logo_url}
                      />
                    </div>

                    <div className="Header_PopUp_Item" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                      <Image
                        src={LanguageIcon}
                        style={{ width: '30px', height: '30px', objectFit: 'contain', opacity: 0.85 }}
                      />
                      <Dropdown
                        placeholder={t("Seleccione un idioma.")}
                        value={i18n.language || language || "es-MX"}
                        onChange={(e, { value }) => {
                          localStorage.setItem('@language', value)
                          const searchParams = new URLSearchParams(location.search);
                          searchParams.set('lang', value);
                          history.push({
                            pathname: location.pathname,
                            search: searchParams.toString()
                          })
                          Localize.setLanguage(value)
                          setLanguage(value)
                          i18n.changeLanguage(value);
                          props.setLanguage(value);
                        }}
                        options={ACTIVE_LANGS.map((lang) => ({
                          key: lang.value,
                          value: lang.value,
                          text: lang.name_en,
                        }))}
                        className='Header_PopUp_Language'
                      />
                    </div>

                    {/* Usuario */}
                    <div className="Header_PopUp_Item" style={{ maxWidth: '220px', overflow: 'hidden' }}>
                      <h4 className="NavBar__InvertedOutline" style={{ maxWidth: '100%', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                        {userName?.toUpperCase()}
                      </h4>
                    </div>

                    {/* Configuración */}
                    <div className="Header_PopUp_Item">
                      <Button
                        onClick={() => handleModalMenuOpen(t('Configuración'))}
                        className="Header_PopUp_Button settings"
                      >
                        {t('Configuración')}
                        <img
                          src={icons.find(i => i.title === 'ConfiguracionUser')?.url}
                          alt={t('Configuración')}
                          className="Header_Button_Icon"
                        />
                      </Button>
                    </div>

                    {/* Logout */}
                    <div className="Header_PopUp_Item">
                      <Button
                        className="Header_PopUp_Button logout"
                        onClick={async () => {
                          try {
                            setIsLoggingOut(true);
                            await logout(user?.id);
                          } catch (error) {
                            console.error("Error al cerrar sesión", error);
                            setIsLoggingOut(false);
                          } finally {
                            logoutModal();
                            props.history.replace(
                              `/login${user?.company?.logo_token ? '?e=' + user?.company?.logo_token : ''}`
                            );
                          }
                        }}
                      >
                        {t('Cerrar sesión')}
                        <img
                          src={icons.find(i => i.title === 'LogOutUser')?.url}
                          alt={t('Cerrar sesión')}
                          className="Header_Button_Icon"
                        />
                      </Button>
                    </div>

                    {/* Notas */}
                    <div className="Header_PopUp_Item">
                      <Button
                        className="Header_PopUp_Button notes"
                        onClick={() => {
                          window.open(
                            'https://docs.google.com/document/d/15aFvfideG8cAsBik3pTpRpwsqlHmgsLZvGaCbrXU30Y/edit?usp=sharing'
                          )
                        }}
                      >
                        {t('Notas de la Versión')} V 0.19.60
                        <img
                          src={icons.find(i => i.title === 'NotasUser')?.url}
                          alt={t('Notas de la Versión')}
                          className="Header_Button_Icon"
                        />
                      </Button >
                    </div >

                  </div >
                </Segment >
              }


              position='bottom right'
            />
          </Menu.Item >
        </Menu.Menu >
      </Menu >

      {isLoggingOut && (
        <ContentOverlayLoader active={isLoggingOut} text={t('Cerrando sesión...')} />
      )}
    </>
  )
}

const mapDispatchToProps = (dispatch) => ({
  getSysModulesRel: (id) => dispatch(sysModuleRelActions.getSysModuleRel(id)),
  loadExpirationReport: (opt) =>
    dispatch(documentItemActions.loadExpirationReport(opt)),
  loadServiceOrders: (options) => dispatch(serviceOrderActions.load(options)),
  loadAndUpdate: (options) =>
    dispatch(serviceOrderActions.loadAndUpdate(options)),
  logout: (option) => dispatch(logout(option)),
  setLanguage: (lang) => dispatch(setLanguage(lang)),
  getReportMaxMin: (options) =>
    dispatch(storageActions.getReportMaxMin(options)),
  getExpiredServiceOrdersCount: (options) =>
    dispatch(serviceOrderActions.getExpiredServiceOrdersCount(options)),
  loadCountOrderServices: () => dispatch(programingServicesActions.loadCountOrderServices()),
  getUnreadInternalOrderNotificationsCount: () => dispatch(internalOrderActions.getUnreadInternalOrderNotificationsCount()),
  setActiveChatId: (id) => dispatch(chat_passengerActions.setActiveChatId(id)),
  loadOnboardingProgress: () => dispatch(onboardingActions.loadOnboardingProgress()),
  updateTourSettings: (userData) => dispatch(userActions.updateTourSeenRoutesSilent(userData)),
  updateAppUser: (partialUser) => dispatch(updateAppUserAction(partialUser)),
  openCommunicationModal: () => dispatch({
    type: `SET_COMMUNICATION_USER`,
    payload: true
  }),
})

const mapStateToProps = (state) => ({
  isAuthenticated: !!state.app.user,
  isClientAuthenticated: !!state.app.client,
  user: state.app.user,
  client: state.app.client,
  passenger: state.app.passenger,
  supplier: state.app.supplier,
  employees: state.employees,
  service_orders: getStateValue(state.service_orders.entities),
  expirations: state.document_items?.expiration_report ?? [],
  lang: state.app?.lang,
  unreadMessages: state.chat_passengers?.unreadMessages,
  onboarding: state.onboarding,
  communicationUsers: getStateValue(state.communication_users.entities),
})

export default connect(mapStateToProps, mapDispatchToProps)(HeaderComponent)
